import styled from 'styled-components';

interface AutoScaledImageProps {
    objectFit?: 'contain' | 'cover';
    inheritWidth?: boolean;
}

const AutoScaledImage = styled.img<AutoScaledImageProps>`
    height: 100%;
    width: ${({ inheritWidth }) => (inheritWidth ? 'inherit' : '100%')};
    object-fit: ${(props) => props.objectFit || 'contain'};
`;

export default AutoScaledImage;
